var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#CCD6DD;}\n\t.st2{fill:#A11922;}\n\t.st3{fill:none;stroke:#BE1622;stroke-width:1.3786;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#B2B2B2;stroke-width:1.5413;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,149.49,62.06,183.78,104.75,183.78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.73,116.91c0,0,26.28-5.79,26.28-41.88c0-0.48-0.01-1.69-0.11-2.12c-0.67-2.98-3.68-3.77-8.83-3.77H83.9 c-2.18,0-5.66-0.27-7.3,1.93c-0.49,0.65-1.62,1.13-1.5,2.4c0.02,0.24,0.08,1,0.08,1.23c0,35.87,26.69,42.21,26.69,42.21v26.49 c0,0-12,6.12-14.39,7.54c-2.58,1.47-0.86,3.83,0.16,4.23c1.72,0.68,5.9,2.88,17.75,2.88c12.14,0,16.23-2.39,17.7-2.88 c0.57-0.19,3.53-2.44,0.03-4.51c-6.22-3.69-13.4-7.27-13.4-7.27V116.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.73,116.91c-2.71,0.32-5.15,0.33-7.85,0v26.49c0,0-12,6.12-14.39,7.54c-2.58,1.47-0.86,3.83,0.16,4.23 c1.72,0.68,5.9,2.88,17.75,2.88c12.14,0,16.23-2.39,17.7-2.88c0.57-0.19,3.53-2.44,0.03-4.51c-6.22-3.69-13.4-7.27-13.4-7.27 L109.73,116.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.9,72.91c0,4.24-9.28,7.68-30.42,7.68c-21.14,0-30.42-3.44-30.42-7.68c0-4.25,9.28-7.68,30.42-7.68 C126.62,65.23,135.9,68.66,135.9,72.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.92,71.41c0.62,7.91,1.45,13.58,3.03,19.78c4.12,16.15,13.48,18.56,20.91,20.95 c3.33,1.08,6.07,1.29,8.4,0.37c7.72-3.03,16.32-10.8,21.08-24.14c1.71-4.8,2.08-9.67,2.58-15.96c0.48-6.11-56.51-0.98-56.51-0.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.47,88.39c0,10.5,10,25.5,24.99,25.5c15,0,26-16.37,26-25.37C113.46,88.52,80.47,88.39,80.47,88.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.46,88.39c0,2.49-11.42,4.5-25.5,4.5c-14.08,0-25.5-2.01-25.5-4.5s11.42-4.5,25.5-4.5 C120.04,83.89,131.46,85.9,131.46,88.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.82,90.97c14.55,3.73,29.8,3.73,44.35,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.41,74.93c18.18,4.67,37.25,4.67,55.43,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/Wine.64466e8409bcbc7687a6289e97171e1d.svg";
export { ForwardRef as ReactComponent };